let swiperBlocks = document.querySelectorAll(".swiper");

// console.log("swiper blocks", swiperBlocks);
const megamenu4 = document.querySelector(".mega4link");
//let

function carouselRender() {
  swiperBlocks.forEach((block) => {
    let swiperSlides = parseInt(block.attributes.slides.value);
    let space = parseInt(block.attributes.space.value);
    let id = block.attributes.id.value;

    let namespace = ".swiper-" + id;
    // if (block.classList.contains(namespace)) {
    //   // console.log("namespace", namespace);
    // } else {
    //   // console.log("not available namespace");
    // }
    const swiper = new Swiper(namespace, {
      // Optional parameters
      direction: "horizontal",
      slidesPerView: "auto",
      spaceBetween: space,
      centeredSlides: false,
      grabCursor: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preloadImages: true,
      updateOnImagesReady: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 540px
        576: {
          slidesPerView: 2,
        },
        // when window width is >= 767px
        767: {
          slidesPerView: swiperSlides,
        },
      },
      pagination: {
        el: ".swiper-pagination",
      },
      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // And if we need scrollbar
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      observer: true,
      observeParents: true,
    });
    
    megamenu4.addEventListener('mouseover', () => {
      // console.log("mega4hover");
      swiper.update();
    })
  });
}
document.addEventListener("shopify:section:load", carouselRender);
document.addEventListener("shopify:section:changed", carouselRender);
document.addEventListener('DOMContentLoaded', carouselRender);

